import { useLayoutEffect, useRef } from 'react'

import UITag from '@/components/UI/UITag'
import { useGSAP } from '@/composables/useGSAP'

export type RunnerGoalSyllableItemCollectedProps = {
  goal: string
}

const angles = [2, 3, -2, -3]

export default function RunnerGoalSyllableItemCollected({ goal }: RunnerGoalSyllableItemCollectedProps) {
  const { gsap } = useGSAP()
  const tagRef = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      const angle = angles[Math.floor(Math.random() * angles.length)]
      gsap
        .timeline()
        .fromTo(
          tagRef.current.querySelector('.tag__background'),
          { scale: 0, transformOrigin: '50% 80%' },
          { scale: 1, duration: 0.3, ease: 'quart.out' },
          0
        )
        .fromTo(
          tagRef.current,
          {
            scale: 0,
            rotate: angle * -12,
            transformOrigin: '50% 80%',
          },
          {
            scale: 1,
            rotate: angle,
            duration: 0.5,
            ease: 'back.out(1.7)',
          },
          0
        )
    })

    return () => ctx.revert()
  }, [tagRef, gsap])

  return (
    <UITag ref={tagRef} rotate={false} theme='mid-blue'>
      {goal}
    </UITag>
  )
}
